import { useEffect } from 'react';
import { history } from '../history';
import { useIsPageHidden } from './useIsPageHidden';
import { useNextApplicationPath } from './useNextApplicationPath';

export function useRedirectToNextApplicationPathIfPageIsHidden(
  page:
    | 'Account'
    | 'Business'
    | 'Payments'
    | 'Business Owner/Financial'
    | 'Documents/Statements',
) {
  const isHidden = useIsPageHidden(page);
  const nextPath = useNextApplicationPath();

  useEffect(() => {
    if (isHidden) history.replace(nextPath!);
  }, [isHidden, nextPath]);

  return isHidden;
}
